import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AcceptedProcessEvent, ParentProcessEvent } from '@shared/models/processEvents';

@Injectable({
  providedIn: 'platform',
})
export class ProcessEventService {
  subject = new Subject<AcceptedProcessEvent | ParentProcessEvent>();

  push(event: AcceptedProcessEvent | ParentProcessEvent) {
    this.subject.next(event);
  }

  subscribe(callback: (event: AcceptedProcessEvent | ParentProcessEvent) => void) {
    return this.subject.subscribe(callback);
  }
}
